module.exports = __webpack_public_path__ + "img/upper_pockets_move_horizontally.7bb775e3.png";